import { Company } from 'generated/apolloComponents'
import React from 'react'
import styles from '../organisms/Company/SocialMediaPanel.module.scss'

interface IProps {
  company: Company
}

const FacebookContainer = ({ company }: IProps) => (
  <section
    className={`${styles['facebook-container']} overflow-auto`}
    style={{ height: '500px' }}
  >
    {company.facebook && (
      <iframe
        title='Facebook'
        allow='encrypted-media'
        scrolling='yes'
        width='100%'
        height={700}
        src={`https://www.facebook.com/plugins/page.php?href=${company.facebook}&show_posts=true&height=700&small_header=true&lazy=true&adapt_container_width=true&hide_cover=true&show_facepile=false&appId=639855146221551`}
        style={{ border: 'none', overflow: 'hidden', width: '100%' }}
      />
    )}
  </section>
)

export default FacebookContainer
